<template>
	<div class="jobs">
		<div style="height: 80px;"></div>
		<div class="cover"></div>
		<div class="jobs_contents">
			<h1>{{ jobTitle }}</h1>
			<p class="desc">涵盖各种岗位类型，覆盖500+热门行业</p>
			<div class="relative width-all" v-if="$route.query.isType == 'true'">
				<div class="jobTabs flex margin-right-md margin-top-md margin-bottom-lgx border-box padding-lr-md">
					<div class="flex transition300" :style="{ 'marginLeft': `-${checkMore * 140}px` }">
						<div v-for="(wtItem, wtIndex) in workList" :key='wtIndex' @click='filterJob(wtItem, wtIndex)'
							:class="[ 'tab', typeActive == wtIndex ? 'active' : '' ]">
							{{ wtItem.title }}
						</div>
					</div>
				</div>
				<div style="right: -10px;top: 0px; height: 100%;width: 60px;
				box-shadow: 0 0 50px 30px rgba(255, 255, 255, 0.9) inset;" class="absolute" v-if="workList.length > 9">
					<div style="width: 32px;height: 32px;background-color: #fff;border-radius: 50%;
					box-shadow: 0px 0px 10px 0px rgba(0,143,255,0.3);margin: 10px auto;cursor: pointer;" @click='checkmore(1)'>
						<i class="icon-ecrt icon-ecrt-right_round text-bdBlue"
							style="font-size: 20px;line-height: 32px;"></i>
					</div>
				</div>
				<div style="left: -10px;top: 0px; height: 100%;width: 60px;
				box-shadow: 0 0 50px 30px rgba(255, 255, 255, 0.9) inset;" class="absolute rotateF180" v-if="checkMore > 0">
					<div style="width: 32px;height: 32px;background-color: #fff;border-radius: 50%;
					box-shadow: 0px 0px 10px 0px rgba(0,143,255,0.3);margin: 10px auto;cursor: pointer;" @click='checkmore(-1)'>
						<i class="icon-ecrt icon-ecrt-right_round text-bdBlue"
							style="font-size: 20px;line-height: 32px;"></i>
					</div>
				</div>
			</div>
			<div style="min-height: 580px;">
				<div class="flex flex-warp space-between">
					<div v-for="(item, index) in jobList" :key='item.id' class="jobListBox">
						<div class="flex space-between">
							<div class="title">
								<span>{{ item.job_name || '岗位名称' }}</span>
							</div>
							<div class="salary">
								{{ item.salaryData }}
							</div>
						</div>
						<div class="flex" style="height: 28px;">
							<div v-for="(tItem, tIndex) in item.tags" :key='tIndex' class="tags">
								{{ tItem }}
							</div>
						</div>
						<div class="flex space-between">
							<div class="company">
								<img src="../static/image/icon/company_icon.png" style="width: 23px;height: 23px;margin-right: 5px;" />
								<span class="padding-top-xs">{{ item.cmp_name }}</span>
							</div>
							<div>
								<el-popover placement="top-start" offset='80' width="200" trigger="click">
									<h2 class="width-all text-center margin-bottom-md">扫码报名</h2>
									<div>
										<div class=" width-all" style="width: 200px;height: 190px;padding-top: 40px;box-sizing: border-box;"
											v-if="!JobDetailUrl">
											<div class="width-all flex flex-center">
												<div class="loader"></div>
											</div>
											<p class="margin-top-md text-center">岗位码生成中...</p>
										</div>
										<img v-else :src="JobDetailUrl" style="width: 200px;height: 200px;" />
									</div>
									<button slot="reference" class="signBtn" @click='sign(item)'>立即报名</button>
								</el-popover>
							</div>
						</div>
					</div>
					<div style="width: 100%;margin: 0 auto;margin-top: 50px;" v-if="!jobList.length">
						<el-empty description="暂无相关岗位,看看其他的吧"></el-empty>
					</div>
				</div>
			</div>
			<el-pagination background layout="prev, pager, next" :page-size='8' :total="total" @current-change='currentChange'> </el-pagination>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import {getJson} from "@/utils/axios";
	import Kit from "@/utils/index.js" // 数据处理模块
	import Header from "@/components/layout/header"
	import Footer from "@/components/layout/footer"
	export default {
		components: {
			Header, Footer
		},
		data() {
			return {
				typeActive: 0,
				checkMore: 0,
				jobTitle: '招工找活',
				pageNumber: 1,
				pageSize: 8,
				total: 0,
				workList: [
					{
						key: '',
						prop: '',
						title: '全部',
					}, {
						key: '日结',
						prop: 'settle_type',
						title: '日结工',
					}, {
						key: '小时工',
						prop: 'settle_type',
						title: '小时工',
					}, {
						key: '计件',
						prop: 'settle_type',
						title: '计件岗',
					}, {
						key: true,
						prop: 'long_term_flg',
						title: '全职岗位',
					},
				],
				jobList: [],
				fiterData: {
					settle_type: ''
				},
				JobDetailUrl: '',
				routeData: ''
			}
		},
		methods: {
			backHome(){
				this.$router.go(-1);
			},
			sign(item){
				this.JobDetailUrl = '';
				axios(
					{
						url: 'https://chat-web.din-job.com/getUnlimitedQRCode',
						method: 'POST',
						data: {
							appId: 'wx6454d9fb93a6cae5',
							secret: 'd69ff7b6c81858a395f428d3d622de72',
							appName: 'ddlg',
							jobId: item.id,
						},
						headers: { 'content-type': 'application/x-www-form-urlencoded'},
					}
				).then( (res) => {
					this.JobDetailUrl = res.data.data;
				}).catch((err) => {
					console.log(err);
					this.$message({message: '提交异常，请联系管理员', type: 'error'});
				});
			},
			currentChange(e){
				this.pageNumber = e;
				this.getJobs();
			},
			checkmore(value) {
				if ((this.checkMore >= this.workList.length - 9) && value > 0) {
					return
				}
				if ((this.checkMore <= 0) && value < 0) {
					return
				}
				this.checkMore += value
			},
			filterJob(item, index) {
				this.typeActive = index
				this.fiterData = {};
				this.fiterData[item.prop] = item.key;
				this.getJobs();
			},
			getJobs() {
				for(const obj in this.fiterData){
					if(!this.fiterData[obj]) delete this.fiterData[obj]
				}
				const city = window.localStorage.getItem('Citys')
					? JSON.parse(window.localStorage.getItem('Citys')).cityValue
					: '';
				getJson('/api/job/page', {
					page_no: this.pageNumber,
					page_size: this.pageSize,
					city: city,
					...this.fiterData
				}, res => {
					this.total = res.totalRow;
					this.jobList = res.list;
					this.jobList.map(item => {
						item.salaryData = item.settle_salary == '面议' ?
							'面议' :
							Kit.salaryJoinType(item.settle_salary, item.settle_type);
					})
				});
			},
			getJobTypes() {
				getJson('/api/mst/jobCategoryL1', {}, res => {
					res.map(item => {
						const obj = {
							key: item.id,
							prop: 'category_l1',
							title: item.category_name,
						}
						this.workList.push(obj);
					});
					const index = this.workList.findIndex( item => item.title == this.$route.query.title)
					this.typeActive = index > 0 ? index : 0;
				});
			},
		},
		created() {
			window.scrollTo({ top: 0, behavior: 'instant'})
			this.fiterData[this.$route.query.prop] = this.$route.query.key;
			if(this.$route.query.isType == 'false'){
				this.jobTitle = this.$route.query.title;
			}
			// this.getJobs();
			// this.getJobTypes();
		}
	}
</script>

<style scoped lang="scss">
	.jobs {
		width: 100%;
		.cover{
			width: 100%;
			padding: 5% 0;
			// height: 252px;
			background: url("../static/image/bg_img/bg07.png") no-repeat;
			background-size:  100% 100%;
		}
		.desc {
			font-size: 22px;
			font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
			font-weight: normal;
			color: #CCCCCC;
			line-height: 33px;
			margin-top: 10px;
			margin-bottom: 70px;
		}
		.jobTabs {
			width: 100%;
			overflow: hidden;

			.tab {
				min-width: 120px;
				height: 52px;
				background: #ebebeb;
				color: #666;
				font-size: 15px;
				border-radius: 4px;
				line-height: 52px;
				margin-right: 10px;
				cursor: pointer;
			}

			.tab:hover {
				background-color: #1768E4;
				color: #fff;
				opacity: 0.8;
			}

			.active {
				background: #1768E4;
				color: #fff;
			}
		}
		.jobs_contents {
			width: 1200px;
			margin: 0 auto;
			padding: 50px 0;
			box-sizing: border-box;

			.jobListBox {
				width: 49%;
				height: 113px;
				background-color: #fff;
				box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.05);
				border: 1px solid #eee;
				border-radius: 8px;
				margin-bottom: 20px;
				padding: 15px;
				box-sizing: border-box;

				.title {
					color: #333;
					font-size: 18px;
					font-weight: 700;
				}

				.salary {
					color: #ff0000;
					font-size: 19px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FF0000;
					line-height: 26px;
					text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
				}

				.tags {
					height: 22px;
					line-height: 22px;
					background: #F1F5F9;
					box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
					border-radius: 11px;
					font-size: 14px;
					margin: 5px 5px 5px 0;
					padding: 0 8px;
				}

				.company {
					margin-top: 3px;
					color: #929292;
					font-size: 14px;
					display: flex;
				}

				.signBtn {
					height: 26px;
					line-height: 28px;
					background: #1768E4;
					box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
					border-radius: 5px;
					border: 0;
					color: #fff;
					font-size: 13px;
					padding: 0 10px;
					cursor: pointer;
				}
				.signBtn:hover{
					background-color: #1768E4;
					opacity: 0.8;
				}
			}

		}
	}
	.loader {
	  width: 60px;
	  height: 60px;
	  display: grid;
	  border: 4.6px solid #0000;
	  border-radius: 100%;
	  border-color: #008cff #0000;
	  animation: spinner-e04l1k 1.5s infinite linear;
	}

	.loader::before, .loader::after {
	  content: "";
	  grid-area: 1/1;
	  margin: 8px;
	  border: inherit;
	  border-radius: 50%;
	}

	.loader::before {
	  border-color: #048be6 #0000;
	  animation: inherit;
	  animation-duration: 0.8s;
	}

	.loader::after {
	  margin: 2.9px;
	}

	@keyframes spinner-e04l1k {
	  100% {
	    transform: rotate(1turn);
	  }
	}
</style>
